import moment from "moment";

export const DEFAULT_OTP_COOLDOWN_SECONDS = 60;

/**
 * Compute remaining seconds until the next OTP request is allowed. Apply for response successfully from OTP API.
 */
export const getOtpRemainingSecondsFromNextRequestAt = (nextRequestAt: unknown): number => {
  if (!nextRequestAt) return 0;
  const seconds = moment(nextRequestAt as any).diff(moment(), "seconds");
  return Math.max(seconds, 0);
};

/**
 * Extract remaining cooldown seconds from a rate-limit error shape:
 * - error.data.error.message === "request rate limited."
 * - error.data.error.errors.rateLimit and error.data.error.errors.diff are numbers
 */
export const getOtpCooldownSecondsFromRateLimitError = (error: unknown): number | null => {
  const e = error as any;
  const status = e?.status ?? e?.data?.status;
  const messageKey = e?.data?.error?.message;
  if (status !== 400 || messageKey !== "request rate limited.") return null;

  const rateLimit = Number(e?.data?.error?.errors?.rateLimit);
  const diff = Number(e?.data?.error?.errors?.diff);
  if (!Number.isFinite(rateLimit) || !Number.isFinite(diff)) return null;
  return Math.max(rateLimit - diff, 0);
};
